/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Legal_UpdatedInputs */

const da_legal_updated = /** @type {(inputs: Legal_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Senest opdateret ${i?.date}`)
};

/** @type {(inputs: Legal_UpdatedInputs) => LocalizedString} */
const en_legal_updated = da_legal_updated;

/**

* @param {Legal_UpdatedInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_updated = /** @type {((inputs: Legal_UpdatedInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_UpdatedInputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_updated(inputs)
	return da_legal_updated(inputs)
});